import { Reveal, SectionLabel } from './Reveal';
import { EXPERTISE } from '../../data/content';
import { Compass, Scale, HeartPulse, FlaskConical } from 'lucide-react';

const ICONS = [Compass, Scale, HeartPulse, FlaskConical];

export const Expertise = () => (
  <section
    id="expertise"
    data-testid="expertise-section"
    className="relative border-t border-white/5 bg-navy-900 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <Reveal>
            <SectionLabel>Our Expertise</SectionLabel>
            <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
              The disciplines that de-risk delivery.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-base leading-relaxed text-slate-300">
            Each mandate draws on four integrated disciplines — the difference
            between a concept and an operational institution.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {EXPERTISE.map((e, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={e.no} delay={i * 0.08}>
              <div className="group flex h-full flex-col border border-white/10 bg-navy-950 p-8 transition-all duration-500 hover:-translate-y-2 hover:border-gold/50">
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center border border-white/10 text-gold transition-colors duration-500 group-hover:border-gold/50">
                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                  </span>
                  <span className="font-serif text-2xl text-white/15 transition-colors duration-500 group-hover:text-gold/40">
                    {e.no}
                  </span>
                </div>
                <h3 className="mt-8 font-serif text-2xl tracking-tight text-white">
                  {e.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-400">
                  {e.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
